/* tslint:disable */
/* eslint-disable */
/**
 * Airline API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime.js';
import { DgChoiceTypeFromJSON, DgChoiceTypeToJSON, } from './DgChoiceType.js';
import { DgCustomerItineraryFromJSON, DgCustomerItineraryToJSON, } from './DgCustomerItinerary.js';
import { DgStatusFromJSON, DgStatusToJSON, } from './DgStatus.js';
/**
 * Check if a given object implements the DgExerciseCustomerResponse interface.
 */
export function instanceOfDgExerciseCustomerResponse(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "contractId" in value;
    isInstance = isInstance && "exerciseInitiatedDateTime" in value;
    isInstance = isInstance && "cashRefundAllowance" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "contractExpiryDateTime" in value;
    isInstance = isInstance && "itinerary" in value;
    isInstance = isInstance && "extAttributes" in value;
    isInstance = isInstance && "currency" in value;
    return isInstance;
}
export function DgExerciseCustomerResponseFromJSON(json) {
    return DgExerciseCustomerResponseFromJSONTyped(json, false);
}
export function DgExerciseCustomerResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'contractId': json['contract_id'],
        'exerciseInitiatedDateTime': (new Date(json['exercise_initiated_date_time'])),
        'exerciseCompletedDateTime': !exists(json, 'exercise_completed_date_time') ? undefined : (new Date(json['exercise_completed_date_time'])),
        'choiceType': !exists(json, 'choice_type') ? undefined : DgChoiceTypeFromJSON(json['choice_type']),
        'cashRefundAllowance': json['cash_refund_allowance'],
        'status': DgStatusFromJSON(json['status']),
        'contractExpiryDateTime': (new Date(json['contract_expiry_date_time'])),
        'itinerary': DgCustomerItineraryFromJSON(json['itinerary']),
        'extAttributes': json['ext_attributes'],
        'currency': json['currency'],
    };
}
export function DgExerciseCustomerResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'contract_id': value.contractId,
        'exercise_initiated_date_time': (value.exerciseInitiatedDateTime.toISOString()),
        'exercise_completed_date_time': value.exerciseCompletedDateTime === undefined ? undefined : (value.exerciseCompletedDateTime.toISOString()),
        'choice_type': DgChoiceTypeToJSON(value.choiceType),
        'cash_refund_allowance': value.cashRefundAllowance,
        'status': DgStatusToJSON(value.status),
        'contract_expiry_date_time': (value.contractExpiryDateTime.toISOString()),
        'itinerary': DgCustomerItineraryToJSON(value.itinerary),
        'ext_attributes': value.extAttributes,
        'currency': value.currency,
    };
}
